<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href=""><i class=""></i></a>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-sm-12">
            <div class="text-center"><img src="../assets/logo.png" width="200" height="70"></div>
            <div class="d-flex justify-content-between mt-3">
              <h4 class="m-0">ADMIN</h4>
              <h6 class="m-0">Login</h6>
            </div>

            <hr class="m-0">
            <div class="mt-5">
              <form action="#" @submit.prevent>
                <div class="col-md-12 col-sm-12 form-group mb-3">
                  <label> Email</label>
                  <input class="form-control txt" type="email" placeholder="Enter your Email" v-model.trim="$v.formInfo.email.$model"  :class="{'is-invalid':$v.formInfo.email.$error, 'is-valid':!$v.formInfo.email.$invalid}">
                </div>

                <div class="col-md-12 col-sm-12 form-group mb-3">
                  <div class="d-flex justify-content-between">
                  <label> Password</label><label class=""> <router-link to="reset_password" style="color:#ccc !important" tabindex="-1">  Forgot your Password ?</router-link>  </label>
                  </div>
                  <input class="form-control txt" type="password" v-model="$v.formInfo.password.$model"  :class="{'is-invalid':$v.formInfo.password.$error, 'is-valid':!$v.formInfo.password.$invalid}">
                </div>

                <div class="form-group mb-3 text-center px-3 mt-5" v-if="!sending">
                  <button class="btn btn-primary btn-sm w-100 text-white" :disabled="$v.formInfo.$invalid || hasVoted == 'true'" type="submit" @click.prevent="login()"> Login </button>
                </div>
                <div class="form-group mb-3 text-center px-3 mt-5" v-if="sending">
                  <button class="btn btn-primary btn-sm w-100 text-white" disabled type="submit"> Login </button>
                </div>

              </form>
              <!-- end form -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->
  </div>
</template>

<script>
import { required, email, minLength} from 'vuelidate/lib/validators'
import { mapActions } from 'vuex';
export default {
  name: 'Login',
  data() {
    return {
      emes:false,
      emessage:'',
      formInfo:{
        email: null,
        password: null
      },
      hasVoted:false, sending:false
    };
  },

  mounted(){
    localStorage.removeItem("XATHWAT");  // Remove token (jwt)
    localStorage.removeItem("GWEND127"); // Remove admin details
    localStorage.removeItem("GWENDMENU"); // Remove admin menus
  },

  validations: {
    formInfo: {
      email: { required, email },
      password: {
        required,
        minLength: minLength(8),
      },
    }
  },

  methods:{
    ...mapActions(["addToken", "addAdminDetails", "addAdminMenu"]),

    login() {
      this.sending=true;
      this.$toastr.removeByType("error"); // remove all error type message
      this.hasVoted=true
      this.$v.formInfo.$touch();
      if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
        this.$toastr.e("Fill forms well");
        this.sending=false;
        return;
      }else{
        const baseU = `${this.$urlAuth}/login`;
        this.$http.post(baseU, this.formInfo)
        .then((result) => {
          // console.log(result)
          if(result.data.data.code =='S200'){

            // save token to localstorage and store
            this.addToken(result.data.data.token)

            // save admin details to localstorage and store
            this.addAdminDetails(result.data.data.user)
            
            // save admin menus to localstorage and store
            this.addAdminMenu(result.data.data.menus)

            this.$router.push({ path: '/dashboard' })
          }else{
            this.sending=false;
            this.$toastr.e(result.data.data.message);
          }
        }).catch(er =>{
          if(er.message == 'Network Error'){
            console.log(er)
            this.sending=false;
            this.$toastr.e("Cannot connect to serve. Check your internet connection");
          }else{
            // console.log("Error---------",er.message)
            console.log(er)
            this.sending=false;
            // this.$toastr.e("Cannot connect to serve. Check your internet connection");
          }
        })
        this.hasVoted=false
      }
    },
  }
}

</script>
